{
  "$id": "wealthlane://forms/transfer-and-allocate/ui",
  "semanticId": "transferAndAllocateForm",
  "page": {
    "goBack": true
  },
  "wrapper": {
    "bordered": true
  },
  "submitBar": {
    "submitLabel": "Create Transfer and Allocate",
    "align": "start",
    "hideCancel": true
  },
  "modes": {
    "create": {
      "page": {
        "title": "Create Transfer and Allocate"
      }
    },
    "edit": {
      "page": {
        "title": "Update Transfer and Allocate"
      },
      "submitBar": {
        "submitLabel": "Update Transfer and Allocate",
        "align": "start",
        "hideCancel": true
      }
    }
  },
  "layout": [
    {
      "rowId": "header",
      "title": "Transfer And Allocate",
      "fields": [
        {
          "scope": "#/properties/name",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 240,
          "maxWidthPx": 600
        },
        {
          "scope": "#/properties/isDrs2BrokerTransferAllocate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 320,
          "style": { "--ui-checkbox-label-size": "13px", "--ui-checkbox-label-lh": "1.4" }
        },
        {
          "type": "spacer",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/description",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 240,
          "maxWidthPx": 600,
          "startNewRow": true
        }
      ]
    }
  ]
}
